export default "__VITE_ASSET__uJsDayBN__"